// import React from 'react';
// import { useTranslation } from 'react-i18next';

// const VesselRemovalPage = ({ onButtonClick, onBack }) => {
//   const { t } = useTranslation();
  
//   const vesselServices = [
//     { name: t('vesselRemovalPage.services.forehead'), price: t('vesselRemovalPage.prices.forehead') },
//     { name: t('vesselRemovalPage.services.noseArea'), price: t('vesselRemovalPage.prices.noseArea') },
//     { name: t('vesselRemovalPage.services.chin'), price: t('vesselRemovalPage.prices.chin') },
//     { name: t('vesselRemovalPage.services.neck'), price: t('vesselRemovalPage.prices.neck') },
//     { name: t('vesselRemovalPage.services.cheekbone'), price: t('vesselRemovalPage.prices.cheekbone') },
//     { name: t('vesselRemovalPage.services.intimate'), price: t('vesselRemovalPage.prices.intimate') },
//     { name: t('vesselRemovalPage.services.noseChin'), price: t('vesselRemovalPage.prices.noseChin') },
//     { name: t('vesselRemovalPage.services.decollete'), price: t('vesselRemovalPage.prices.decollete') },
//     { name: t('vesselRemovalPage.services.hemangioma'), price: t('vesselRemovalPage.prices.hemangioma') },
//     { name: t('vesselRemovalPage.services.pointVessel'), price: t('vesselRemovalPage.prices.pointVessel') },
//     { name: t('vesselRemovalPage.services.legsAbove'), price: t('vesselRemovalPage.prices.legsAbove') },
//     { name: t('vesselRemovalPage.services.legsBelow'), price: t('vesselRemovalPage.prices.legsBelow') },
//     { name: t('vesselRemovalPage.services.poikiloderma10'), price: t('vesselRemovalPage.prices.poikiloderma10') },
//     { name: t('vesselRemovalPage.services.poikiloderma20'), price: t('vesselRemovalPage.prices.poikiloderma20') },
//     { name: t('vesselRemovalPage.services.back'), price: '' }
//   ];

//   const handleServiceClick = (serviceName, servicePrice) => {
//     if (serviceName === t('vesselRemovalPage.services.back')) {
//       onBack();
//     } else {
//       onButtonClick(serviceName, servicePrice);
//     }
//   };

//   return (
//     <>
//       <header className="header">
//         <div className="clinic-logo">
//           <div className="logo-icon">🩸</div>
//           <h1>{t('vesselRemovalPage.title')}</h1>
//         </div>
        
//         <div className="user-greeting">
//           <p>{t('vesselRemovalPage.subtitle')}</p>
//         </div>
//       </header>

//       <main className="main-content">
//         <div className="welcome-section">
//           <h2>{t('vesselRemovalPage.welcome')}</h2>
//           <p className="subtitle">{t('vesselRemovalPage.effectiveRemoval')}</p>
//         </div>

//         <div className="buttons-grid">
//           {vesselServices.map((service, index) => (
//             <button 
//               key={index}
//               className={`service-btn ${service.name === t('vesselRemovalPage.services.back') ? 'back-btn' : ''}`}
//               onClick={() => handleServiceClick(service.name, service.price)}
//             >
//               <div className="service-info-full">
//                 <span className="service-name-full">{service.name}</span>
//                 {service.price && <span className="service-price">{service.price}</span>}
//               </div>
//             </button>
//           ))}
//         </div>
//       </main>

//       <footer className="footer">
//         <p>{t('vesselRemovalPage.footer.main')}</p>
//         <p className="footer-info">{t('vesselRemovalPage.footer.info')}</p>
//       </footer>
//     </>
//   );
// };

// export default VesselRemovalPage;



import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const VesselRemovalPage = ({ onButtonClick, onBack }) => {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState([]);
  
  const vesselServices = [
    { id: 1, name: t('vesselRemovalPage.services.forehead'), price: t('vesselRemovalPage.prices.forehead') },
    { id: 2, name: t('vesselRemovalPage.services.noseArea'), price: t('vesselRemovalPage.prices.noseArea') },
    { id: 3, name: t('vesselRemovalPage.services.chin'), price: t('vesselRemovalPage.prices.chin') },
    { id: 4, name: t('vesselRemovalPage.services.neck'), price: t('vesselRemovalPage.prices.neck') },
    { id: 5, name: t('vesselRemovalPage.services.cheekbone'), price: t('vesselRemovalPage.prices.cheekbone') },
    { id: 6, name: t('vesselRemovalPage.services.intimate'), price: t('vesselRemovalPage.prices.intimate') },
    { id: 7, name: t('vesselRemovalPage.services.noseChin'), price: t('vesselRemovalPage.prices.noseChin') },
    { id: 8, name: t('vesselRemovalPage.services.decollete'), price: t('vesselRemovalPage.prices.decollete') },
    { id: 9, name: t('vesselRemovalPage.services.hemangioma'), price: t('vesselRemovalPage.prices.hemangioma') },
    { id: 10, name: t('vesselRemovalPage.services.pointVessel'), price: t('vesselRemovalPage.prices.pointVessel') },
    { id: 11, name: t('vesselRemovalPage.services.legsAbove'), price: t('vesselRemovalPage.prices.legsAbove') },
    { id: 12, name: t('vesselRemovalPage.services.legsBelow'), price: t('vesselRemovalPage.prices.legsBelow') },
    { id: 13, name: t('vesselRemovalPage.services.poikiloderma10'), price: t('vesselRemovalPage.prices.poikiloderma10') },
    { id: 14, name: t('vesselRemovalPage.services.poikiloderma20'), price: t('vesselRemovalPage.prices.poikiloderma20') }
  ];

  const toggleService = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleBookAppointment = () => {
    const selectedServiceNames = vesselServices
      .filter(service => selectedServices.includes(service.id))
      .map(service => `${service.name} - ${service.price}`);
    
    if (selectedServiceNames.length > 0) {
      onButtonClick(`Запись на удаление сосудов: ${selectedServiceNames.join('; ')}`);
    } else {
      onButtonClick('Запись на консультацию по удалению сосудов');
    }
  };

  const totalPrice = vesselServices
    .filter(service => selectedServices.includes(service.id))
    .reduce((sum, service) => {
      const priceStr = service.price.replace(' руб.', '').replace(/\s/g, '');
      return sum + (parseInt(priceStr) || 0);
    }, 0);

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">🩸</div>
          <h1>{t('vesselRemovalPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('vesselRemovalPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('vesselRemovalPage.welcome')}</h2>
          <p className="subtitle">{t('vesselRemovalPage.effectiveRemoval')}</p>
        </div>

        <div className="services-list-section">
          <div className="services-scroll-container">
            {vesselServices.map((service) => (
              <div 
                key={service.id}
                className={`service-item ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                onClick={() => toggleService(service.id)}
              >
                <div className="service-checkbox">
                  {selectedServices.includes(service.id) ? '✓' : ''}
                </div>
                <div className="service-info-full" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span className="service-name-full" style={{ color: 'white' }}>{service.name}</span>
                  {service.price && (
                    <span className="service-price" style={{ color: 'white' }}>{service.price}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedServices.length > 0 && (
          <div className="services-total" style={{ margin: '20px 0', padding: '15px', background: 'rgba(255,255,255,0.1)', borderRadius: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="total-label" style={{ color: 'white' }}>Выбрано зон:</span>
            <span className="total-count" style={{ background: 'rgba(52,152,219,0.3)', padding: '5px 12px', borderRadius: '20px', color: 'white' }}>{selectedServices.length}</span>
            <span className="total-price" style={{ color: '#2ecc71', fontSize: '18px', fontWeight: '700' }}>{totalPrice} руб.</span>
          </div>
        )}

        <div className="buttons-grid">
          <button 
            className="service-btn book-btn" 
            onClick={handleBookAppointment}
            style={selectedServices.length > 0 ? { background: 'linear-gradient(135deg, rgba(39, 174, 96, 0.9), rgba(46, 204, 113, 0.9))' } : {}}
          >
            <span className="btn-icon">📅</span>
            <span className="btn-text" style={{ color: 'white' }}>
              {selectedServices.length > 0 ? 'Записаться на выбранные зоны' : 'Записаться на консультацию'}
            </span>
          </button>

          <button 
            className="service-btn back-btn"
            onClick={onBack}
          >
            <span className="btn-icon">←</span>
            <span className="btn-text" style={{ color: 'white' }}>{t('vesselRemovalPage.services.back')}</span>
          </button>
        </div>
      </main>

      <footer className="footer">
        <p>{t('vesselRemovalPage.footer.main')}</p>
        <p className="footer-info">{t('vesselRemovalPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default VesselRemovalPage;